export type InteractivityPoll = {
  id: number;
  name: string;
  question: string;
  entity_uri: string;
  type: 'SINGLE_CHOICE' | 'MULTIPLE_CHOICE';
  status: 'LIVE' | 'DRAFT' | 'CLOSED';
  opening_date: string;
  closing_date: string;
  options: Option[];
};
export type Option = {
  option: string;
  total_votes: number;
  poll_id: number;
  option_id: number;
};

export type InteractivityPollsResponse = {
  poll: InteractivityPoll;
};

export async function fetchInteractivityPoll(
  episodeId: string
): Promise<InteractivityPollsResponse> {
  try {
    const response = await fetch(
      `/api/proxy/v3/episodes/webEpisodeId:${episodeId}/poll`
    );
    if (response.ok) {
      return response.json();
    }
    throw new Error('Response not ok');
  } catch (e) {
    console.warn('Error fetching from Interactivity API: ', e);
    throw new Error(e.message);
  }
}
